const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_AuditList":
      return { ...state, List: payload };
    case "SAVE_AuditFilters":
      return { ...state, Filters: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
